import {createStore, applyMiddleware} from "redux"
import thunkMiddleware from "redux-thunk"
import rootReducer from "../reducer"

const middlewares = [thunkMiddleware]

const enhancers = [
  applyMiddleware(...middlewares),
  // other store enhancers if any
]

export default function configureStore(initialState = {}) {
  return createStore(rootReducer, initialState, ...enhancers)
}
